import { Box, Flex } from '@chakra-ui/react';
import { BiReportEmbed } from 'components/reports';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect, useMemo, useState } from 'react';
import { getReportToken } from 'services/api/requests/biIntegration';
import { BiReportType } from 'services/api/variables/external/biExplorer';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

import { renderHelpContent } from './variables/helpContent';

export default function Accuracy() {
	const helpAccuracy: ISidebarHelp = useMemo(
		() => ({
			title: 'Acuracidade',
			firstParagraph: '',
			renderContentAsJSX: true,
			helpContentJSX: renderHelpContent(),
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;
	const [accuracyToken, setAccuracyToken] = useState<string>('');

	useEffect(() => {
		setDataSidebar(helpAccuracy);
	}, [helpAccuracy, setDataSidebar]);

	useEffect(() => {
		const fetchToken = async () => {
			const token = await getReportToken(BiReportType.ACCURACY_REPORT);
			setAccuracyToken(token);
		};
		fetchToken();
	}, []);

	return (
		<Flex
			direction='column'
			pt={{ base: '130px', md: '80px', xl: '80px' }}
			px={{ base: 4, md: 6 }}
			gap={6}
			height='100vh'
		>
			<Box
				flex='1'
				minHeight='600px'
			>
				<BiReportEmbed
					reportToken={accuracyToken}
					containerHeight='calc(100vh - 200px)'
					autoLoad={true}
				/>
			</Box>
		</Flex>
	);
}

export {};
